module.exports = __webpack_public_path__ + "img/QRpre.a8a14f7d.png";